import logo from './logo.svg';
import './App.css';
import NavigationMenu from './navigation/navigationMenu';
import React from 'react';
import Loginpage from "./content/loginPage"
import { BrowserRouter as Router, Route, Routes,Navigate } from 'react-router-dom';
import Dashboard from './content/dashboard/Dashboard'
import useUserActivity from './content/hooks/useUserActivity';
import authService from './content/hooks/authService';
 import { useAlert } from './content/Alert/Alert';
import Blog from '././content/Blog/Blog'
import RideBookingForm from '././content/dashboard/RideBookingForm'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Login } from '@mui/icons-material';
import Layout from './content/Layout';
import PackagesPage from './content/Packages/Package';
import TariffPage from './content/Teriff/teriff';
import SalemToBangalore from './content/Blog/SalemToBangalore';

import { CommonContextProvider } from './content/modal/Context';
import BillGeneration from './content/BillGeneration/BillGeneration';
import ContactUs from './content/dashboard/ContactUs';
import TaxiServicePage from './content/dashboard/TaxiServicePage';
import TeriffPageForm from './content/Teriff/TeriffPageForm';
import StructuredData from './content/StructuredData';
import SalemCab from './content/dashboard/SalemCab';
import SalemTaxi
 from './content/dashboard/SalemTaxi';
 import SalemBestCab from './content/dashboard/SalemBestCab';
 import SalemBestTaxi from './content/dashboard/SalemBestTaxi';
 import SalemCabService from './content/dashboard/SalemCabService';
import SalemTaxiService from './content/dashboard/SalemTaxiService';

function App() {

    const [token, setToken] = React.useState(authService.getToken());
    const [lastActivityTime, setLastActivityTime] = React.useState(new Date().getTime());

      const {showAlert ,authToken} = useAlert();


  const handleUserActivity = () => {
    console.log("User activity detected");
    setLastActivityTime(Date.now()); // Update the last activity time
  };

  // Use the custom hook to monitor user activity
  useUserActivity(handleUserActivity);

    const handleTokenRenew = async () => {
      try {
       // const newToken = await authService.refreshToken(token);
        setToken("varatharajtoken");
      } catch (error) {
        // Handle the error if needed
      }
    };

    useUserActivity(() => {
      setLastActivityTime(new Date().getTime());
      if(authService.getToken()!=null){
        setToken(authService.getToken);
      }

      if (token) {
       // authService.checkTokenExpiration(token, handleTokenRenew);
      }
    });

    // React.useEffect(() => {
    //   const intervalId = setInterval(() => {
    //     if (authService.isInactive(lastActivityTime)) {
    //       authService.logout();
    //     }
    //   }, 60 * 1000); // Check every minute

    //   return () => clearInterval(intervalId);
    // }, [lastActivityTime]);

  const isAuthenticated = Boolean(localStorage.getItem('authToken')); // Check for authentication

//const isAuthenticated = authToken;

  return (
    <CommonContextProvider>
    <div className="App">
      <Router>
      <Routes >
        
   <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Loginpage />} /> 
      
      <Route path="/" element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/booking" element={<RideBookingForm />} />
                <Route path="/package" element={<PackagesPage />} />
                <Route path="/teriff" element={<TariffPage />} />
                <Route path="/salem-to-bangalore" element={<SalemToBangalore />} />
                <Route path='/bill-generation' element={<BillGeneration/>} />
                <Route path='/contact' element={<ContactUs/>} />
                <Route path='/about' element={<TaxiServicePage/>} />
                <Route path='/teriff-page-form' element={<TeriffPageForm/>} />
                <Route path="/salem-cab" element={<SalemCab />} />
                <Route path="/salem-taxi" element={<SalemTaxi />} />
                <Route path="/salem-taxi-service" element={<SalemTaxiService />} />
                <Route path="/salem-cab-service" element={<SalemCabService />} />
                <Route path="/salem-best-cab" element={<SalemBestCab />} />
                <Route path="/salem-best-taxi" element={<SalemBestTaxi />} />
              
                </Route>
      </Routes>
    </Router>
    </div>
    </CommonContextProvider>
    
  );
}

export default App;
